module.exports = __webpack_public_path__ + "od-empty-wishlist/od-empty-wishlist-8d1292a2e85650213254f5da0f5c5b69.svg";